export var ActivityType;
(function (ActivityType) {
    ActivityType["TASK_CREATED"] = "TASK_CREATED";
    ActivityType["TASK_UPDATED"] = "TASK_UPDATED";
    ActivityType["TASK_STATUS_CHANGED"] = "TASK_STATUS_CHANGED";
    ActivityType["TASK_COMPLETED"] = "TASK_COMPLETED";
    ActivityType["TASK_DUE_DATE_CHANGED"] = "TASK_DUE_DATE_CHANGED";
    ActivityType["TASK_SECURITY_DEADLINE_CHANGED"] = "TASK_SECURITY_DEADLINE_CHANGED";
    ActivityType["TASK_FATAL_DEADLINE_CHANGED"] = "TASK_FATAL_DEADLINE_CHANGED";
    ActivityType["TASK_ASSIGNEE_CHANGED"] = "TASK_ASSIGNEE_CHANGED";
    ActivityType["TASK_TITLE_CHANGED"] = "TASK_TITLE_CHANGED";
    ActivityType["TASK_DESCRIPTION_CHANGED"] = "TASK_DESCRIPTION_CHANGED";
    ActivityType["TASK_PRIORITY_CHANGED"] = "TASK_PRIORITY_CHANGED";
    ActivityType["TASK_TYPE_CHANGED"] = "TASK_TYPE_CHANGED";
    ActivityType["TASK_LOCATION_CHANGED"] = "TASK_LOCATION_CHANGED";
    ActivityType["PROCESS_CREATED"] = "PROCESS_CREATED";
    ActivityType["CLIENT_CREATED"] = "CLIENT_CREATED";
})(ActivityType || (ActivityType = {}));
